import { render, staticRenderFns } from "./list-table-loader.vue?vue&type=template&id=5b4bf696&scoped=true"
import script from "./list-table-loader.vue?vue&type=script&lang=js"
export * from "./list-table-loader.vue?vue&type=script&lang=js"
import style0 from "./list-table-loader.vue?vue&type=style&index=0&id=5b4bf696&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4bf696",
  null
  
)

export default component.exports